/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './generator.defs'
export { main as default } from './generator.defs'
